import {
  Card,
  CardContent,
  Typography,
  CardActions,
  Link,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { SuppliesDetailCardData } from "../../../core/models/suppliesDetail/suppliesDetail.model";
import theme from "../../../muiTheme";
import React from "react";
import LoadingComponentComponent from "../../UI/LoadingComponentComponent/LoadingComponentComponent";
import { useNavigate } from "react-router-dom";

interface SuppliesDetailCardProps {
  cardData: SuppliesDetailCardData;
  isLoading: boolean;
}

const SuppliesDetailCard = ({
  cardData: { title, titleIcon, data, navigateTo, height },
  isLoading,
}: SuppliesDetailCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card sx={{ marginBottom: 2 }}>
      <CardContent
        sx={{
          padding: "1.5rem",
          paddingBottom: 0,
          display: "flex",
          columnGap: 2,
          flexDirection: "column",
          position: "relative",
          height,
          [theme.breakpoints.down("md")]: {
            height: "auto",
            minHeight: "22rem",
          },
        }}
      >
        <Typography component="h3" variant="h3" marginBottom="1.5rem">
          {titleIcon && <span className={`${titleIcon} brand-red`} />}{" "}
          {t(title)}
        </Typography>
        {isLoading ? (
          <LoadingComponentComponent
            isLoading={isLoading}
            backgroundColor={"transparent"}
            position={"absolute"}
          />
        ) : (
          data.map(({ id, label, value, renderContent }) => {
            return (
              <React.Fragment key={id}>
                <Typography
                  variant="caption"
                  component="h4"
                  sx={{ color: "grey.700", marginBottom: 0.5 }}
                >
                  {t(label)}
                </Typography>
                {renderContent ? (
                  renderContent(value)
                ) : (
                  <Typography
                    gutterBottom
                    variant={"body1"}
                    component="p"
                    fontWeight={400}
                    marginBottom="1.5rem"
                  >
                    {value}
                  </Typography>
                )}
              </React.Fragment>
            );
          })
        )}
      </CardContent>
      {navigateTo && (
        <CardActions
          sx={{
            paddingLeft: "1.5rem",
            paddingBottom: "1.5rem",
            paddingTop: "1.5rem",
            justifySelf: "end",
          }}
        >
          <Link
            component="button"
            underline="none"
            onClick={() => navigate(navigateTo)}
            variant="button"
            display={"flex"}
            alignItems={"center"}
            gap={"10px"}
            sx={{ position: "unset" }}
          >
            <Typography
              component="span"
              aria-hidden="true"
              className="t-icon-edit"
            />
            {t("Actualizar")}
          </Link>
        </CardActions>
      )}
    </Card>
  );
};

export default SuppliesDetailCard;
